import React, { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import pen from '../images/pen.png'
import page from '../images/paper.png';
const All = () => {
  const [open ,setOpen] = useState(false)
  return (
    <div className="bg-[#f0f4fc] min-h-screen">
      <div className=" p-10">
        <div className="flex items-center justify-between">
        <p className="text-2xl font-semibold">All Applicants</p>
        <div className="relative">
        <button className={!open?"py-2 h-full  bg-[#148EFF] text-white px-12 rounded-lg":"py-2 h-full  bg-[#148EFF] text-white px-12 rounded-t-lg"} onClick={()=>{setOpen(!open)}}>Add Applicants</button>
        {
          open &&
        <div className="flex flex-col bg-[#5AA7EF] absolute w-full text-white rounded-b-lg">
          <button>
            <div className="flex items-center space-x-3 py-3 px-3">
              <img src={pen} className="h-6"></img>
              <p>Manually</p>
            </div>
          </button>
          <button>
            <div className="flex items-center space-x-4 py-3 px-3">
              <img src={page} className="h-6"></img>
              <p>Files</p>
            </div>
          </button>
        </div>
        }
        </div>
        </div>
        <div className="p-4 mt-6 bg-white rounded-xl">
          <div className="flex w-full items-end justify-start space-x-5">
            <div>
              <p className="font-semibold">Job title</p>
              <select className="border px-1 py-1 rounded-lg mt-1"  >
                <option value="i">Introduction</option>
                <option value="ct">Critical Thinking</option>
                <option value="ls">Active Listening</option>
                <option value="gm">Growth Mindset</option>
                <option value="comm">Communication</option>
                <option value="tw">Teamwork</option>
              </select>
            </div>
            <div>
              <p className="font-semibold">Date</p>
              <input className="border px-1 py-1 rounded-lg mt-1"  type="date"></input>
            </div>
            <div>
              <p className="font-semibold">Status</p>
              <select className="border w-32 px-1 py-1 outline-none rounded-lg mt-1"  >
                <option value="i">Shortlised</option>
                <option value="ct">Pending</option>
                <option value="ls">Rejected</option>
              </select>
            </div>
            <button className="py-2 h-full  bg-[#148EFF] text-white px-12 rounded-lg">Search</button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default All